import { memo } from 'react';

import DayPanelEventRow from './guardian-event-row/day-panel-event-row';
import StandardEventRow from './guardian-event-row/standard-event-row';
import type { GuardianEventRowProps } from './guardian-event-row/types';

function GuardianEventRow(props: GuardianEventRowProps) {
  const variant = props.variant ?? 'card';

  if (variant === 'dayPanel') {
    return <DayPanelEventRow {...props} />;
  }

  return <StandardEventRow {...props} variant={variant} />;
}

export type {
  GuardianEventRowDate,
  GuardianEventRowProps,
  GuardianEventRowVariant,
} from './guardian-event-row/types';
export default memo(GuardianEventRow);
